export const wpRequest = (action, data) => (
   new Promise((resolve, reject) => {
      jQuery.ajax({
         type: 'POST',
         data: {action, ...data},
         url: ajaxurl,
         success: function (response) {
            resolve(response);
         },
         error: function (xhr, status, err) {
            reject(err);
         }
      });
   })
);